// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ResetPassword.css */

.reset-password-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.reset-password-container input {
  background-color: #ffffff !important;
  color: #333 !important;
}

.reset-password-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 450px;
  width: 100%;
  padding: 40px;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.reset-password-card h1 {
  color: #333;
  margin-bottom: 8px;
  font-size: 26px;
  font-weight: 700;
}

.reset-password-card .subtitle {
  color: #666;
  margin-bottom: 25px;
  font-size: 14px;
  line-height: 1.5;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 600;
  font-size: 14px;
}

.form-group small {
  display: block;
  margin-top: 4px;
  color: #28a745;
  font-size: 12px;
}

.form-group input {
  width: 100%;
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
  font-family: inherit;
  background-color: #ffffff !important;
  color: #333 !important;
}

.form-group input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
}

.form-group .readonly-input {
  background-color: #f8f9fa;
  cursor: not-allowed;
  color: #666;
  border-color: #ddd;
}

.form-group input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}

.message {
  padding: 14px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  border-left: 4px solid;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message.success {
  background-color: #d4edda;
  color: #155724;
  border-color: #28a745;
}

.message.error {
  background-color: #f8d7da;
  color: #721c24;
  border-color: #dc3545;
}

.message.info {
  background-color: #d1ecf1;
  color: #0c5460;
  border-color: #17a2b8;
}

.submit-btn {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: inherit;
  margin-top: 10px;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.password-requirements {
  background: #f8f9fa;
  padding: 14px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 13px;
  color: #666;
  border-left: 3px solid #e0e0e0;
}

.requirement {
  margin: 6px 0;
  padding-left: 0;
  color: #999;
  transition: color 0.2s;
  font-weight: 500;
}

.requirement.met {
  color: #28a745;
}

.loading {
  text-align: center;
  color: #666;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 50px 20px;
}

.spinner {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #667eea;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
}

.spinner-inline {
  display: inline-block;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.link-text {
  text-align: center;
  margin-top: 20px;
  color: #666;
  font-size: 14px;
}

.link-text a {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s;
}

.link-text a:hover {
  color: #764ba2;
  text-decoration: underline;
}

.error-actions {
  text-align: center;
  padding: 20px;
  color: #721c24;
}

.error-actions p {
  margin-bottom: 15px;
  font-size: 14px;
}

.back-link {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.2s;
}

.back-link:hover {
  background-color: #c82333;
}

/* Responsive design */
@media (max-width: 600px) {
  .reset-password-card {
    padding: 30px 20px;
  }

  .reset-password-card h1 {
    font-size: 22px;
  }

  .form-group input {
    padding: 11px;
    font-size: 16px; /* Prevents zoom on iOS */
  }

  .submit-btn {
    padding: 11px;
    font-size: 15px;
  }

  .loading {
    padding: 40px 10px;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .reset-password-container {
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  }

  .reset-password-card {
    background: #0f3460;
    color: white;
  }

  .reset-password-card h1 {
    color: #e0e0e0;
  }

  .reset-password-card .subtitle {
    color: #a0a0a0;
  }

  .form-group label {
    color: #e0e0e0;
  }

  .form-group input {
    background-color: #1a1a2e;
    border-color: #333;
    color: #e0e0e0;
  }

  .form-group input::placeholder {
    color: #666;
  }

  .form-group input:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.2);
  }

  .form-group .readonly-input {
    background-color: #2a2a3e;
    color: #888;
    border-color: #333;
  }

  .password-requirements {
    background: #1a1a2e;
    color: #a0a0a0;
    border-left-color: #333;
  }

  .link-text {
    color: #a0a0a0;
  }

  .link-text a {
    color: #667eea;
  }

  .link-text a:hover {
    color: #764ba2;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ResetPassword.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,6DAA6D;EAC7D,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,4DAA4D;AAC9D;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,oBAAoB;EACpB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe,EAAE,yBAAyB;EAC5C;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,6DAA6D;EAC/D;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,8CAA8C;EAChD;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* ResetPassword.css */\n\n.reset-password-container {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.reset-password-container input {\n  background-color: #ffffff !important;\n  color: #333 !important;\n}\n\n.reset-password-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  max-width: 450px;\n  width: 100%;\n  padding: 40px;\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.reset-password-card h1 {\n  color: #333;\n  margin-bottom: 8px;\n  font-size: 26px;\n  font-weight: 700;\n}\n\n.reset-password-card .subtitle {\n  color: #666;\n  margin-bottom: 25px;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: #333;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.form-group small {\n  display: block;\n  margin-top: 4px;\n  color: #28a745;\n  font-size: 12px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.3s, box-shadow 0.3s;\n  font-family: inherit;\n  background-color: #ffffff !important;\n  color: #333 !important;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);\n}\n\n.form-group .readonly-input {\n  background-color: #f8f9fa;\n  cursor: not-allowed;\n  color: #666;\n  border-color: #ddd;\n}\n\n.form-group input:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.message {\n  padding: 14px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  border-left: 4px solid;\n  animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.message.success {\n  background-color: #d4edda;\n  color: #155724;\n  border-color: #28a745;\n}\n\n.message.error {\n  background-color: #f8d7da;\n  color: #721c24;\n  border-color: #dc3545;\n}\n\n.message.info {\n  background-color: #d1ecf1;\n  color: #0c5460;\n  border-color: #17a2b8;\n}\n\n.submit-btn {\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-family: inherit;\n  margin-top: 10px;\n}\n\n.submit-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);\n}\n\n.submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.password-requirements {\n  background: #f8f9fa;\n  padding: 14px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  font-size: 13px;\n  color: #666;\n  border-left: 3px solid #e0e0e0;\n}\n\n.requirement {\n  margin: 6px 0;\n  padding-left: 0;\n  color: #999;\n  transition: color 0.2s;\n  font-weight: 500;\n}\n\n.requirement.met {\n  color: #28a745;\n}\n\n.loading {\n  text-align: center;\n  color: #666;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 50px 20px;\n}\n\n.spinner {\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #667eea;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  animation: spin 1s linear infinite;\n}\n\n.spinner-inline {\n  display: inline-block;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  width: 14px;\n  height: 14px;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.link-text {\n  text-align: center;\n  margin-top: 20px;\n  color: #666;\n  font-size: 14px;\n}\n\n.link-text a {\n  color: #667eea;\n  text-decoration: none;\n  font-weight: 600;\n  transition: color 0.2s;\n}\n\n.link-text a:hover {\n  color: #764ba2;\n  text-decoration: underline;\n}\n\n.error-actions {\n  text-align: center;\n  padding: 20px;\n  color: #721c24;\n}\n\n.error-actions p {\n  margin-bottom: 15px;\n  font-size: 14px;\n}\n\n.back-link {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: background-color 0.2s;\n}\n\n.back-link:hover {\n  background-color: #c82333;\n}\n\n/* Responsive design */\n@media (max-width: 600px) {\n  .reset-password-card {\n    padding: 30px 20px;\n  }\n\n  .reset-password-card h1 {\n    font-size: 22px;\n  }\n\n  .form-group input {\n    padding: 11px;\n    font-size: 16px; /* Prevents zoom on iOS */\n  }\n\n  .submit-btn {\n    padding: 11px;\n    font-size: 15px;\n  }\n\n  .loading {\n    padding: 40px 10px;\n  }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  .reset-password-container {\n    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);\n  }\n\n  .reset-password-card {\n    background: #0f3460;\n    color: white;\n  }\n\n  .reset-password-card h1 {\n    color: #e0e0e0;\n  }\n\n  .reset-password-card .subtitle {\n    color: #a0a0a0;\n  }\n\n  .form-group label {\n    color: #e0e0e0;\n  }\n\n  .form-group input {\n    background-color: #1a1a2e;\n    border-color: #333;\n    color: #e0e0e0;\n  }\n\n  .form-group input::placeholder {\n    color: #666;\n  }\n\n  .form-group input:focus {\n    border-color: #667eea;\n    box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.2);\n  }\n\n  .form-group .readonly-input {\n    background-color: #2a2a3e;\n    color: #888;\n    border-color: #333;\n  }\n\n  .password-requirements {\n    background: #1a1a2e;\n    color: #a0a0a0;\n    border-left-color: #333;\n  }\n\n  .link-text {\n    color: #a0a0a0;\n  }\n\n  .link-text a {\n    color: #667eea;\n  }\n\n  .link-text a:hover {\n    color: #764ba2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
